/**
 * Metrics Data - Key Performance Indicators
 * Quantifiable achievements and statistics
 */

export const metrics = [
  {
    id: 1,
    value: "99.9%",
    label: "Uptime Maintained",
    icon: "🔥",
    description: "Consistent production reliability across fintech platforms",
    color: "var(--color-accent)"
  },
  {
    id: 2,
    value: "50+",
    label: "Projects Delivered",
    icon: "🚀",
    description: "From MVPs to enterprise-scale platforms",
    color: "var(--color-accent-alt)"
  },
  {
    id: 3,
    value: "472GB",
    label: "Data Migrated Safely",
    icon: "💾",
    description: "Zero data loss in critical migrations",
    color: "var(--color-accent)"
  },
  {
    id: 4,
    value: "<200ms",
    label: "Avg API Response",
    icon: "⚡",
    description: "Optimized backend performance",
    color: "var(--color-accent-alt)"
  }
];

// Additional detailed metrics (for About/Stats page)
export const detailedMetrics = {
  technical: {
    systemsBuilt: "15+ production systems",
    codeReviews: "1000+ pull requests reviewed",
    apiEndpoints: "200+ REST endpoints designed",
    databaseOptimizations: "50+ query optimizations",
    dockerContainers: "30+ containerized applications"
  },

  business: {
    transactionVolume: "$2M+ monthly (current platform)",
    usersServed: "10,000+ end users",
    clientsManaged: "Multiple B2B brands",
    projectSuccessRate: "95%+ on-time delivery"
  },

  leadership: {
    teamsLed: "5+ engineering team members",
    projectsOverseen: "20+ concurrent projects",
    stakeholderMeetings: "100+ client presentations",
    technicalDecisions: "Architecture for 10+ major systems"
  },

  devOps: {
    serversManaged: "20+ production servers",
    deploymentsPerMonth: "50+ deployments",
    incidentResponseTime: "< 15 minutes average",
    backupRecovery: "100% success rate"
  }
};

// Timeline metrics
export const timelineMetrics = {
  yearsOfExperience: 5,
  yearsProgramming: 12, // Since age 15
  companiesWorkedWith: 4,
  industriesServed: ["Fintech", "E-commerce", "Crowdfunding", "Enterprise SaaS"]
};

// Technology usage metrics
export const technologyMetrics = {
  primaryLanguages: {
    PHP: "5+ years",
    JavaScript: "5+ years",
    Python: "3+ years"
  },
  frameworkExpertise: {
    Symfony: "5+ years (core competency)",
    "Vue.js": "5+ years",
    React: "2+ years",
    Django: "2+ years"
  },
  infrastructureYears: {
    Docker: "4+ years",
    Linux: "5+ years",
    Nginx: "4+ years"
  }
};

export default metrics;
